document.addEventListener('DOMContentLoaded', function() {
  const items = document.querySelectorAll('.why-trust-us__item');
  const images = document.querySelectorAll('.why-trust-us__image');

  items.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      const index = this.getAttribute('data-index');

      // Remove active from all items
      items.forEach(function(i) { i.classList.remove('why-trust-us__item--active'); });
      images.forEach(function(i) { i.classList.remove('why-trust-us__image--active'); });

      // Add active to current
      this.classList.add('why-trust-us__item--active');
      document.querySelector('.why-trust-us__image[data-index="' + index + '"]').classList.add('why-trust-us__image--active');
    });
  });
});
